import React from 'react'
import { useState, useEffect, useRef } from 'react'
import { ScrollView, Text, TouchableOpacity, View } from 'react-native'
import { FormContentsModel, PerfectStoreTagsModel } from './models/StoreDetailModel'
import theme from '../../../theme'
import styles from './FormHorizontalTagsStyles'
import { colorFilterSelected, colorFilterUnselected } from '../../../themeConstants'
import { FormContent } from '../../services/interfaces/schedule.interface/schedule.getstore.interface'

export const FormHorizontalTags = ({
    tags,
    data,
    onClickTag,
}: {
    tags: PerfectStoreTagsModel[]
    data?: FormContentsModel[]
    onClickTag: (id: string, data?: FormContentsModel[]) => void
}) => {
    const [selectedTag, setSelectedTag] = useState('-1')

    const onClick = (id: string) => {
        setSelectedTag(id)
        onClickTag(id, data)
    }
    return (
        <ScrollView style={styles.scrollView} horizontal={true}>
            <>
                {tags.map((tag, index) => {
                    const isSelected = selectedTag === tags[index]._id.toString()

                    return (
                        <TagItem
                            key={tag._id.toString()}
                            name={tag.name}
                            id={tag._id.toString()}
                            data={data}
                            onClickTag={onClick}
                            isSelected={isSelected}
                        />
                    )
                })}
            </>
        </ScrollView>
    )
}

export const TagItem = ({
    name,
    id,
    data,
    onClickTag,
    isSelected,
}: {
    name: string
    id: string
    data?: FormContentsModel[]
    onClickTag: (id: string) => void
    isSelected: boolean
}) => {
    //console.log('🚀 ~ data:', data[0])
    return (
        <View style={styles.containerLabels}>
            <TouchableOpacity
                onPress={() => onClickTag(id)}
                style={[
                    styles.flatFlagsPrimary,
                    {
                        backgroundColor: isSelected ? colorFilterSelected : 'white',
                        borderColor: isSelected ? colorFilterSelected : colorFilterUnselected,
                    },
                ]}
            >
                <Text style={isSelected ? styles.flatItemsSelectedPrimary : styles.flatItemsUnselectedPrimary}>{name}</Text>
            </TouchableOpacity>
        </View>
    )
}
